<template>
  <GlobalWindow
    title="创建服务商"
    :visible.sync="visible"
    :show="true"
    width="400px"
    @confirm="confirm"
    @closeDialog="close"
  >
    <el-form label-width="100px">
      <el-form-item label="服务商名称：">
        <el-input
          v-model.trim="form.service_name"
          min-width="100px"
        />
      </el-form-item>
      <el-form-item
        v-if="flag === 1"
        label="服务商账号："
      >
        <el-input v-model="form.account" />
      </el-form-item>
      <el-form-item
        v-if="flag === 2"
        label="ID："
      >
        <el-input
          v-model="currentID"
          disabled
        />
      </el-form-item>
      <el-form-item label="bm_id:">
        <el-input
          v-model.trim="form.bm_id"
          min-width="100px"
        />
      </el-form-item>
    </el-form>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/GlobalWindow'
// import PaginationRight from '@/components/PaginationRight/index.vue'
// import moment from 'moment'
export default {
  name: 'AddModifyServiceProvider',
  components: { GlobalWindow },
  data() {
    return {
      currentRowData: {},
      visible: false,
      currentID: null, // 当前行数据的ID
      form: {
        service_name: null,
        account: null,
        bm_id: null
      },
      flag: null // 1 为创建  2 为修改
    }
  },
  methods: {
    open(data, flag) {
      this.visible = true
      if (flag === 2) {
        const { id, account, bm_id, service_name } = data
        this.currentID = id// 获取当前行的ID
        this.form.account = account // 不能让这为空 随便给个值
        this.form.bm_id = bm_id
        this.form.service_name = service_name
      } else if (flag === 1) {
        this.form.account = null
        this.form.bm_id = null
      }
      this.flag = flag
    },
    // 关闭dialog
    close() {
      this.form = {}
    },
    // 确认按钮
    confirm() {
      if (!this.form.service_name || !this.form.account) {
        this.$message({
          message: this.flag === 1 ? '任一添加项不能为空' : '修改项不能为空',
          type: 'error'
        })
        return
      }
      switch (this.flag) {
        case 1:
          this.$emit('addConfirm', this.form)
          break
        case 2:
          this.$emit('modifyConfirm', this.currentID, { service_name: this.form.service_name, bm_id: this.form.bm_id })
          break
      }
      this.form = {}
      this.visible = false
    }
  }
}
</script>

<style scoped>
</style>
